import type { ColumnDef } from "@tanstack/react-table";
import { buildTagColumn, buildTwoLineColumn } from "@/components/Table";
import type { TagType } from "@/components/Tag/Tag";
import { formatStatus } from "@/features/person/utils/utils";
import { toFormat } from "@/lib/dateHelpers";
import type { ParticipationHistoryTableRow } from "../../types";

const REGISTRATION_STATUS_TAG_TYPES: Record<string, TagType> = {
  ACTIVE: "success",
  CANCELLED: "surface",
  WAITLIST: "warn",
  PENDING: "warn"
};

export function getRegistrationStatusTagType(status?: string | null): TagType {
  const normalized = status?.trim().toUpperCase() ?? "";

  return REGISTRATION_STATUS_TAG_TYPES[normalized] ?? "surface";
}

export function getParticipationHistoryColumns(): ColumnDef<ParticipationHistoryTableRow, unknown>[] {
  return [
    buildTwoLineColumn<ParticipationHistoryTableRow>({
      accessorKey: "eventName",
      header: "Event",
      getPrimaryText: (row) => row.eventName,
      getSecondaryText: (row) => row.programName,
      secondaryLabel: "Program",
      size: 300
    }),
    {
      accessorKey: "eventStartDate",
      header: "Start Date",
      enableSorting: false,
      size: 140,
      cell: ({ row }) => <div>{toFormat(row.original.eventStartDate) ?? "--"}</div>
    },
    {
      accessorKey: "eventEndDate",
      header: "End Date",
      enableSorting: false,
      size: 140,
      cell: ({ row }) => <div>{toFormat(row.original.eventEndDate) ?? "--"}</div>
    },
    {
      accessorKey: "registrationDate",
      header: "Registration Date",
      enableSorting: false,
      size: 160,
      cell: ({ row }) => <div>{toFormat(row.original.registrationDate) ?? "--"}</div>
    },
    buildTagColumn<ParticipationHistoryTableRow>({
      accessorKey: "registrationStatus",
      header: "Registration Status",
      getTagLabel: (row) => formatStatus(row.registrationStatus ?? undefined),
      getTagType: (row) => getRegistrationStatusTagType(row.registrationStatus),
      getTagStyle: () => "strong",
      size: 140
    })
  ];
}
